import { Link } from "react-router-dom";
import { Linkedin, MessageCircle, Send } from "lucide-react";

const footerLinks = {
  Services: [
    { name: "AI Development", href: "/services/ai-development" },
    { name: "AI Agents", href: "/services/ai-agents" },
    { name: "Custom Tools", href: "/services/custom-tools" },
    { name: "Mobile Apps", href: "/services/mobile-development" },
    { name: "eCommerce", href: "/services/ecommerce-development" },
    { name: "Payment Gateways", href: "/services/payment-gateways" },
    { name: "Custom Development", href: "/services/custom-development" },
    { name: "WordPress", href: "/services/wordpress-woocommerce" },
    { name: "Support", href: "/services/post-launch-support" },
  ],
  Company: [
    { name: "Case Studies", href: "/case-studies" },
    { name: "About", href: "/about" },
    { name: "Contact", href: "/contact" },
  ],
};

const socialLinks = [
  { icon: Linkedin, href: "https://www.linkedin.com/company/onepixteam", label: "LinkedIn" },
  { icon: MessageCircle, href: "https://wa.me/message/7LSTVCZDQZ27H1", label: "WhatsApp", color: "hover:text-[hsl(142,70%,45%)]" },
  { icon: Send, href: "https://t.me/onepixteam", label: "Telegram", color: "hover:text-primary" },
];

export default function Footer() {
  return (
    <footer className="border-t border-border/50 bg-background">
      <div className="container mx-auto px-4 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-1">
            <Link to="/" className="text-xl font-bold tracking-tight text-foreground">
              One<span className="text-primary">Pix</span>
            </Link>
            <p className="mt-1 text-xs text-muted-foreground">AI & Custom Web Development</p>
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
              We build what you were going to keep paying for.<br />Miami, Florida, USA.
            </p>
            <p className="mt-4 text-sm text-muted-foreground">
              <a href="mailto:info@onepix.net" className="transition-colors hover:text-primary">info@onepix.net</a>
            </p>
            <div className="mt-4 flex gap-3">
              {socialLinks.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className={`inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border/50 text-muted-foreground transition-colors hover:bg-muted/50 ${s.color || "hover:text-foreground"}`}
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <p className="mb-4 text-sm font-semibold text-foreground">{title}</p>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.href}>
                    <Link to={link.href} className="text-sm text-muted-foreground transition-colors hover:text-foreground">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <p className="mb-4 text-sm font-semibold text-foreground">Connect</p>
            <ul className="space-y-2.5">
              <li><a href="https://www.linkedin.com/company/onepixteam" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground transition-colors hover:text-foreground">LinkedIn</a></li>
              <li><a href="https://wa.me/message/7LSTVCZDQZ27H1" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground transition-colors hover:text-foreground">WhatsApp</a></li>
              <li><a href="https://t.me/onepixteam" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground transition-colors hover:text-foreground">Telegram</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-border/50 pt-8 sm:flex-row">
          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} OnePix. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-muted-foreground transition-colors hover:text-foreground">Privacy Policy</a>
            <a href="#" className="text-xs text-muted-foreground transition-colors hover:text-foreground">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
